import { BattleState } from "../types";

/**
 * Простая стейт-машина: хранит текущий стейт и валидирует переходы.
 * Сами действия по входу в стейт делаются в BattleScene.
 */
export class BattleStateMachine {
  private state: BattleState = BattleState.Intro;
  private listeners: Array<(s: BattleState) => void> = [];

  get current(): BattleState {
    return this.state;
  }

  transition(next: BattleState): void {
    this.state = next;
    this.listeners.forEach((l) => l(next));
  }

  onChange(cb: (s: BattleState) => void): void {
    this.listeners.push(cb);
  }
}
